import {
  OpenAPI as ConfigurationOpenAPI,
  type ReconciliationSpecCreateOperation,
} from '@festina/configuration-general-types/configuration'
import { useMutation } from '@tanstack/react-query'

import { fetchFromService } from '../fetchFromService'

type TriggerProps = {
  reconciliationSpecCreateOperation: ReconciliationSpecCreateOperation
}

/**
 * Converts a reconciliation-spec create operation back into the Excel document it was
 * authored in.
 *
 * The service answers with the document bytes, which the generated client decodes as
 * text and thereby corrupts, so the request is issued manually.
 */
export const useMutateConvertReconciliationSpecCreateOperationToExcel = () =>
  useMutation({
    mutationFn: async ({ reconciliationSpecCreateOperation }: TriggerProps) => {
      const response = await fetchFromService({
        serviceConfig: ConfigurationOpenAPI,
        serviceName: 'configuration',
        path: '/conversion/reconciliationspec/convert-to-format',
        method: 'POST',
        body: JSON.stringify(reconciliationSpecCreateOperation),
        headers: { 'Content-Type': 'application/json' },
        errorMessage:
          'Failed to convert the reconciliation-spec create operation to Excel',
      })

      return await response.blob()
    },
  })
